import { useObservable } from "@zkt/eb-utility";
import { iframeMessage$, IframeMessage } from "@/observables/iframe-message";

export function useIframeMessage(): MessageEvent<IframeMessage> {
  return useObservable(iframeMessage$);
}
